import { render, staticRenderFns } from "./setHoliday.vue?vue&type=template&id=73624923&scoped=true"
import script from "./setHoliday.vue?vue&type=script&lang=js"
export * from "./setHoliday.vue?vue&type=script&lang=js"
import style0 from "./setHoliday.vue?vue&type=style&index=0&id=73624923&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73624923",
  null
  
)

export default component.exports